<div class="form-group">
    <div class="row fields-group">
        <div class="col-auto">
            <label class="input-label">{{ 'dets.predicate' | translate }}</label>
            <select class="form-control"
                    [(ngModel)]="operator"
                    (ngModelChange)="operatorValueChanged()">
                <option *ngFor="let o of operators" [ngValue]="o">{{ o | translate }}</option>
            </select>
        </div>
        <div class="col" *ngIf="!isOperatorIsValid()">
            <label class="input-label">{{ 'dets.predicate_value' |
        translate }}</label>
            <input class="form-control"
                   type="number"
                   name="numericValue"
                   [(ngModel)]="numericValue"
                   (ngModelChange)="numericValueChanged($event)">
            
            <label class="input-label mt-2">{{ 'dets.comparison_field_label' | translate }}</label>
            <search-select *ngIf="fields.length > 0"
                    (change)="onTargetFormFieldKeyChange($event)"
                    [items]="fields"
                    [selected]="sourceFormFieldKey"
                    [placeholder]="'Choose here' | translate"></search-select>
        </div>
    </div>
</div>
